    <div class="position-relative">
        <app-user-pofile-pic 
         [profile_pic_image]="connection_pic_image">
        </app-user-pofile-pic>
    </div>